import { AxiosResponse, CancelToken } from "axios";

import { SystemAdherenceDTO } from "../models/dto/SystemAdherenceDTO";

import { api } from "./api";

export const findSystemAdherenceData = (
  type: string,
  dataInicio: string,
  dataFim: string,
  cancelToken?: CancelToken,
): Promise<AxiosResponse<SystemAdherenceDTO>> => {
  return api.get(`gdp/relatorios/utilizacao-ponto/${type.toLowerCase()}`, {
    ...(cancelToken || {}),
    params: {
      dataInicio,
      dataFim,
    },
  });
};
